import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BodyComponent } from "reactjs-human-body";
import { PartsInput } from "reactjs-human-body/dist/components/BodyComponent/BodyComponent";
import React, { useEffect, useState, useRef } from "react";
import TextInput from "../../../../common/PicklistTesxBox";
import { fetchSubjectInfo } from "../../../../services/Case_SubjectAPI";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import DateRangePicker from "../../../../common/CustomDateRangePicker";
// import { ReactSVG } from "react-svg";
import isEqual from "lodash.isequal";
import moment from "moment";
import {
  Container,
  Row,
  Form,
  Col,
  Button,
  FloatingLabel,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import {
  CASE_STAGE_STATUS,
  PARTY_TYPES,
  SERVICE_PROVIDER_DEFAULT,
  STAKEHOLDER_LIST_CODE,
} from "../../../../common/Constant";
import { format } from "date-fns";
import {
  FetchNatureOfInjury,
  FetchSaverityOfInjury,
  FetchInjuryType,
  AddInjury,
  FetchInjuryDetails,
  updateInjuryDetails,
} from "../../../../services/InjuryAPI"; // Import the API function
import DataTable from "../../../../common/DataTable";
import Snackbar from "../../../../common/Snackbar";

import { INJURY_HEADERS, INJURY_LOG_HEADERS } from "../actions/constant";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import { current } from "@reduxjs/toolkit";
import { Checkbox, FormControlLabel } from "@mui/material";
import AccordionComponent from "../../../../common/Accordion";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import { useIsStageReadOnly } from "../../../../utils/caseStageChecker";
import {
  fetchCaseheaderinfo,
  fetchCaseStakeholderList,
} from "../../../../services/CaseInformationApi";
import { setInjuryAvailable } from "../../../../redux/slice/CaseHeaderSlice";
import { fetchQMEDoctorContacts } from "../../../../services/ScheduleAppointmentApi";
interface PicklistGroup {
  value: string;
  label: string;
}
interface AddCaseSubjectProps {
  userData: any;
  action: string;
  loggedInUserid: any;
  caseStageId: any;
  caseInfoID: any;
  caseSubjectID: number | null;
  selectedRowData: any;
  claimnumber: any;
  //userdataCalaimNumber: any;
  genderNew: string | null;
  caseSubjectInjuryID: any;
  onCancel: (action: string) => void;
  activeKey: any;
  onTabChange: () => void;
}
const stakeholderTypeMap: { [key: string]: string } = {
  "Insurance Carrier": STAKEHOLDER_LIST_CODE.INSURANCE,
};
const formattedDateTime = (date: string | Date): string | null => {
  if (!date) {
    console.error("Invalid input: date is required.");
    return null;
  }

  // Format date as "YYYY-MM-DD" and append "T00:00:00"
  const formattedDate = moment(date).format("YYYY-MM-DD");
  return `${formattedDate}T00:00:00`;
};

const InjuryForm: React.FC<AddCaseSubjectProps> = ({
  userData,
  //action,
  loggedInUserid,
  caseStageId,
  caseInfoID,
  caseSubjectID,
  selectedRowData,
  claimnumber,
  genderNew,
  onCancel,
  activeKey,
  onTabChange,
  caseSubjectInjuryID,
}) => {
  const [insurance, setInsurance] = useState<number | null>(null);

  const dispatchNew = useDispatch<AppDispatch>();
  //const { claimnumber } = useSelector((state: RootState) => state.caseHeader);
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const { isInjuryAvailable } = useSelector(
    (state: RootState) => state.caseHeader,
  );
  const [gender, setGender] = useState<string | null>(null);
  const [showPreviousAddress, setShowPreviousAddress] = useState(true);
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const isStageNonEditable = useIsStageReadOnly();
  const [injuryData, setInjuryData] = useState<any[]>([]);
  const [injuryDataDuplicateClaimno, setaDuplicateClaimno] = useState<any[]>(
    [],
  );
  const [selectedBodyParts, setSelectedBodyParts] = useState<string[]>([]);
  const [selectedPartsObject, setSelectedPartsObject] = useState<PartsInput>(
    {} as PartsInput,
  );
  const [InjuryLogDetails, setInjuryLogDetails] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [isAddingMoreInjury, setIsAddingMoreInjury] = useState(false);
  const [selectedParts, setSelectedParts] = useState<string[]>([]);

  const [selectedInsurance, setSelectedInsurance] = useState<any[]>([]);

  const bodyParts = [{ name: "Ankle", coords: "75,350" }];

  const getCaseSubject = async () => {
    try {
      const subjectInfo = await fetchSubjectInfo(caseInfoID);

      if (subjectInfo?.genderName) {
        setGender(subjectInfo.genderName);
      } else {
        console.warn("No genderName found in response.");
      }
    } catch (error) {
      console.error("Error fetching subject info:", error);
    }
  };
  useEffect(() => {
    getCaseSubject();
  }, [caseSubjectID, caseInfoID]);

  const [activeView, setActiveView] = useState("front"); // 'front' or 'back'

  const normalize = (str: any) =>
    str.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase();

  const handleSelect = (parts: string, view: any) => {
    const isDisabled = !isChanged || view_Case || isStageNonEditable;
    if (isDisabled) return; // 🚫 block if disabled

    // if (view !== activeView) return; // Only allow selection on active view (if you want this rule)
    setSelectedParts((prev) =>
      prev.includes(parts) ? prev.filter((p) => p !== parts) : [...prev, parts],
    );
  };

  const [showLogDrawer, setShowLogDrawer] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const handlePDFClick = () => {
    //   if (!subjectIDToUpdate) return; // Ensure an address is selected
    setInjuryLogDetails(InjuryLogDetails); //
    setShowLogDrawer(true);
    setShowTooltip(false);
    // };
    const handleCloseLogDrawer = () => {
      setShowLogDrawer(false);
    };
  };

  const dispatch = useDispatch();
  const { caseSubjectId } = useSelector(
    (state: RootState) => state.caseSubject,
  );
  const initialForm = {
    caseSubjectInjuryID: undefined as number | undefined,
    caseSubjectID: caseSubjectID ? caseSubjectID : caseSubjectId,
    caseInfoID: caseInfoID,
    injuryTypeId: 0,
    dateOfIncident: "",
    doictStartDate: "",
    doictEndDate: "",
    claimNumber: "",
    severityOfInjuryId: 0,
    natureOfInjuryId: [],
    insuranceCarrierId: 0,
    qmeDoctorContactId: 0,
    injuryDetails: "",
    additionalComments: "",
    isMainInjury: false,
    bodyPartsAffected: "",
    additionalBodyPartsAffected: "",
    createdBy: 0,
  };
  const [isChanged, setIsChanged] = useState(false);
  const initialFormRef = useRef(initialForm);
  const [formData, setFormData] = useState({
    caseSubjectInjuryID: undefined as number | undefined, // ✅ Fix here
    caseSubjectID: caseSubjectID ? caseSubjectID : caseSubjectId,
    caseInfoID: caseInfoID,
    injuryTypeId: 0,
    dateOfIncident: "",

    doictStartDate: "", // ✅ Add this
    doictEndDate: "", // ✅ Add thisha
    claimNumber: "",
    severityOfInjuryId: 0,
    isMainInjury: false,
    natureOfInjuryId: [],
    insuranceCarrierId: 0,
    qmeDoctorContactId: 0,
    injuryDetails: "",
    additionalComments: "",
    bodyPartsAffected: "", // This will store selected body parts
    additionalBodyPartsAffected: "",
    createdBy: 0,
  });
  useEffect(() => {
    const changed = !isEqual(formData, initialFormRef.current);
    setIsChanged(changed);
  }, [formData]);

  useEffect(() => {
    if (formData.bodyPartsAffected) {
      setSelectedParts(
        formData.bodyPartsAffected.split(", ").map((p) => p.trim()),
      );
    }
  }, [formData.bodyPartsAffected]);

  const [saverityOfInjuryOptions, setsaverityOfInjuryOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [InjuryTypeOptions, setInjuryTypeOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [insuranceOptions, setInsuranceOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<
    {
      value: string;
      label: string;
      specialization: string;
      contactFullName: string;
    }[]
  >([]);
  const [natureOfInjuryOptions, setNatureOfInjuryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const selectedOption = InjuryTypeOptions.find(
    (opt) => Number(opt.value) === formData.injuryTypeId,
  );

  const [insuranceCarrierIDs, setinsuranceCarrierIDs] = useState<any>();
  const [insuranceCarrierID, setInsuranceCarrierId] = useState<number | null>(
    null,
  );
  const [qmeDoctorContactId, setQmeDoctorContactId] = useState<number | null>(
    null,
  );

  useEffect(() => {
    if (userData) {
      setFormData((prevState) => ({
        ...prevState,
        //caseSubjectID: userData.caseInfoID || 0, // Assuming caseInfoID is the subject ID
        caseInfoID: caseInfoID || 0,
        claimNumber: userData?.masterClaimNumber || "",
      }));
    }
  }, [userData]);

  useEffect(() => {
    const getInsuranceCarrier = async () => {
      try {
        const subjectInfo = await fetchCaseStakeholderList("IN", 1);
        setInsuranceOptions(subjectInfo);
        const doctorInfo = await fetchQMEDoctorContacts(loggedInUserid);
        setQMEDoctorOptions(doctorInfo);
      } catch (error) {
        console.error("Error fetching subject info:", error);
      }
    };
    getInsuranceCarrier();
  }, []); // trigger when `caseSubjectID` changes
  const fetchCaseInsuranceCarrierinfo = async () => {
    try {
      const response = await fetchCaseheaderinfo(caseInfoID); // Your API call

      // ✅ Save full case info if needed

      const carrierId = response.insuranceCarrierId || null;
      setInsuranceCarrierId(carrierId);
      const doctorId = response.qmeDoctorContactId || null;
      setQmeDoctorContactId(doctorId);
    } catch (error) {
      console.error("Error fetching insurance carrier info:", error);
      setInsuranceCarrierId(null);
    }
  };

  useEffect(() => {
    fetchCaseInsuranceCarrierinfo();
  }, [insuranceOptions]);

  useEffect(() => {
    const getCaseSubject = async () => {
      try {
        if (caseSubjectID) {
          const subjectInfo = await fetchSubjectInfo(caseSubjectID);
          if (subjectInfo?.caseSubjectID) {
            setcaseSubjectID(subjectInfo.caseSubjectID);
          } else {
            console.warn("No caseSubjectID found in response.");
          }
        }
      } catch (error) {
        console.error("Error fetching subject info:", error);
      }
    };

    getCaseSubject();
  }, [caseSubjectID]); // Runs when `caseid` changes

  useEffect(() => {
    FetchNatureOfInjury()
      .then(setNatureOfInjuryOptions)
      .catch(() => {
        setSnackbarMessage("Error fetching Nature of Injury.");
        setSnackbarOpen(true);
      });
  }, []);

  useEffect(() => {
    FetchSaverityOfInjury()
      .then(setsaverityOfInjuryOptions)
      .catch(() => {
        setSnackbarMessage("Error fetching Nature of Injury.");
        setSnackbarOpen(true);
      });
  }, []);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      bodyPartsAffected: selectedParts.join(", "), // Convert array to string
    }));
  }, [selectedParts]);

  useEffect(() => {
    FetchInjuryType()
      .then(setInjuryTypeOptions)
      .catch(() => {
        setSnackbarMessage("Error fetching Nature of Injury.");
        setSnackbarOpen(true);
      });
  }, []);

  useEffect(() => {
    const changed = !isEqual(formData, initialFormRef.current);
    setIsChanged(changed);
  }, [formData]);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // const handleDateChange = (date: Date | null) => {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     dateOfIncident: date ? date.toISOString().split("T")[0] : "", // Ensure proper format
  //   }));
  // };
  const handleDateChange = (date: Date | null) => {
    setFormData((prevState) => ({
      ...prevState,
      dateOfIncident: date
        ? date.toLocaleDateString("en-CA") // outputs YYYY-MM-DD in local time
        : "",
    }));
  };

  const [dateFrom, setDateFrom] = useState<string | null>(null);
  const [dateTo, setDateTo] = useState<string | null>(null);
  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;

    setDateRange([start, end]);
    const formattedStart = start ? moment(start).format("YYYY-MM-DD") : "";
    const formattedEnd = end ? moment(end).format("YYYY-MM-DD") : "";

    setDateFrom(formattedStart);
    setDateTo(formattedEnd);

    // ✅ Update formData too
    setFormData((prev) => ({
      ...prev,
      doictStartDate: formattedStart,
      doictEndDate: formattedEnd,
    }));
  };

  useEffect(() => { }, [caseSubjectInjuryID]);
  useEffect(() => {
    if (!selectedRowData && isAddingMoreInjury && caseSubjectInjuryID > 1) {
      setFormData((prev) => ({ ...prev, claimNumber: "" }));
    } else if (
      !selectedRowData &&
      !formData.claimNumber &&
      userData?.masterClaimNumber
    ) {
      setFormData((prev) => ({
        ...prev,
        claimNumber: userData.masterClaimNumber,
      }));
    }
  }, [selectedRowData, isAddingMoreInjury, caseSubjectInjuryID, userData]);

  const handleDropdownChange = (
    name: string,
    value: string | number | null,
  ) => {
    setFormData((prevState) => {
      let parsedValue: number | string | null = value;

      // Only convert to number if it's a numeric string
      if (typeof value === "string" && !isNaN(Number(value))) {
        parsedValue = Number(value);
      }

      const newState = {
        ...prevState,
        [name]: parsedValue,
      };
      const handleDropdownChangeType = (
        name: string,
        value: string | number | null,
      ) => {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value, // store the text like "Specific"
        }));

        setIsChanged(true);
      };

      // Reset date fields based on injury type
      if (name === "injuryTypeId") {
        if (parsedValue === 1) {
          newState.doictStartDate = "";
          newState.doictEndDate = "";
        } else if (parsedValue === 2) {
          newState.dateOfIncident = "";
        }
      }

      return newState;
    });

    setIsChanged(true);
  };

  const handleBack = () => {
    onCancel("Cancel");
  };
  useEffect(() => { }, [formData.natureOfInjuryId]);
  useEffect(() => {
    if (formData.doictStartDate || formData.doictEndDate) {
      setDateRange([
        formData.doictStartDate ? new Date(formData.doictStartDate) : null,
        formData.doictEndDate ? new Date(formData.doictEndDate) : null,
      ]);
    }
  }, [formData.doictStartDate, formData.doictEndDate]);

  const handleAddMoreInjury = () => {
    // Show "Add More Injury" only when caseSubjectInjuryID > 1
    if (caseSubjectInjuryID > 1) {
      setflagSave(false);

      setIsEditing(false);
      setSelectedParts([]);

      setFormData({
        caseSubjectInjuryID: undefined,
        caseSubjectID: caseSubjectID,
        caseInfoID: caseInfoID,
        injuryTypeId: 0,
        dateOfIncident: "",
        doictStartDate: "",
        doictEndDate: "",
        claimNumber: "",
        severityOfInjuryId: 0,
        natureOfInjuryId: [],
        insuranceCarrierId: 0,
        qmeDoctorContactId: 0,
        injuryDetails: "",
        additionalComments: "",
        isMainInjury: false,
        bodyPartsAffected: "",
        additionalBodyPartsAffected: "",
        createdBy: 0,
      });
      setDateRange([null, null]);
      setSelectedBodyParts([]);
    } else {
      console.log("🔒 Injury form not shown — caseSubjectInjuryID must be > 1");
    }
  };

  const [isEditing, setIsEditing] = useState(false);
  const [flagSave, setflagSave] = useState(false);

  useEffect(() => {
    if (selectedRowData) {
      setFormData((prevState) => ({
        ...prevState,
        caseSubjectInjuryID: selectedRowData.caseSubjectInjuryID || null,
        caseSubjectID: selectedRowData.caseSubjectID || 0,
        caseInfoID: selectedRowData.caseInfoID || 0,
        injuryTypeId: selectedRowData.injuryTypeID || 0,
        dateOfIncident: selectedRowData.dateOfIncident
          ? selectedRowData.dateOfIncident.split("T")[0]
          : "",
        doictStartDate: selectedRowData.doictStartDate
          ? selectedRowData.doictStartDate.split("T")[0]
          : "",
        doictEndDate: selectedRowData.doictEndDate
          ? selectedRowData.doictEndDate.split("T")[0]
          : "",
        claimNumber: selectedRowData.claimNumber || "",
        severityOfInjuryId: selectedRowData.severityOfInjuryID || 0,

        // natureOfInjuryId: selectedRowData.natureOfInjuryID
        //   ? selectedRowData.natureOfInjuryID
        //       .split(",")
        //       .map((id: string): string => id.trim())
        //   : [],
        insuranceCarrierId: selectedRowData.insuranceCarrierId || 0,
        qmeDoctorContactId: selectedRowData.qmeDoctorContactId || 0,
        natureOfInjuryId: selectedRowData.natureOfInjuryID
          ? selectedRowData.natureOfInjuryID.split(",").map(Number)
          : [],
        // insuranceCarrierId: Array.isArray(selectedRowData.insuranceCarrierId)
        //   ? selectedRowData.insuranceCarrierId.map(Number)
        //   : typeof selectedRowData.insuranceCarrierId === "string"
        //   ? selectedRowData.insuranceCarrierId.split(",").map(Number)
        //   : [],

        ///////////////////////////////// insurance Carrier code here //////////////////////
        injuryDetails: selectedRowData.injuryDetails || "",
        additionalComments: selectedRowData.additionalComments || "",
        isMainInjury: selectedRowData.isPrimaryInjury === 1 || selectedRowData.isPrimaryInjury === true,
        bodyPartsAffected: selectedRowData.bodyPartsAffected || "",
        additionalBodyPartsAffected:
          selectedRowData.additionalBodyPartsAffected || "",
        createdBy: selectedRowData.createdBy || 0,
        modifiedBy: selectedRowData.modifiedBy || 0,
        createdByName: selectedRowData.createdByName || "",
        modifiedByName: selectedRowData.modifiedByName || "",
      }));
      const formatDate = (dateString: string | null) => {
        if (!dateString) return "";

        const date = new Date(dateString);
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${month}/${day}/${year} | ${hours}:${minutes}`;
      };
      const formattedCreatedDate = selectedRowData.createdDate
        ? moment(selectedRowData.createdDate).format("MM/DD/YYYY | hh:mm A")
        : "N/A";

      const formattedModifiedDate = selectedRowData.modifiedDate
        ? moment(selectedRowData.modifiedDate).format("MM/DD/YYYY | hh:mm A")
        : "N/A";
      const formattedLogDetails = [
        {
          createdByName: selectedRowData.createdByName || "",
          createdDate: formattedCreatedDate,
          modifiedByName: selectedRowData.modifiedByName || "",
          modifiedDate: formattedModifiedDate,
        },
      ];
      setInjuryLogDetails(formattedLogDetails);
      setDateRange([
        selectedRowData?.doictStartDate
          ? selectedRowData?.doictStartDate?.split("T")[0]
          : null,
        selectedRowData?.doictEndDate
          ? selectedRowData?.doictEndDate?.split("T")[0]
          : null,
      ]);
    } else {
      console.warn("Action does not match 'edit'. Received:", action);
    }
    // ✅ Log inside `useEffect` to confirm state update
  }, [selectedRowData]);

  useEffect(() => {
    fetchInjuryDetails();
    if (
      activeKey == "Injury" &&
      !selectedRowData &&
      caseSubjectInjuryID > 1 &&
      caseSubjectInjuryID != null
    ) {
      handleAddMoreInjury(); // Call the form reset logic
      const defaultInjuryType = InjuryTypeOptions.find(
        (opt) => opt.label === "Specific",
      );

      if (defaultInjuryType) {
        setFormData((prev) => ({
          ...prev,
          injuryTypeId: Number(defaultInjuryType.value), // ✅ Ensure number
        }));
      }
    }
  }, [activeKey, selectedRowData, formData.caseSubjectInjuryID]);
  const [injuryDatas, setInjuryDatas] = useState(null);

  const fetchInjuryDetails = async () => {
    try {
      const response = await FetchInjuryDetails(caseSubjectId);
      if (response?.isSuccess) {
        setInjuryData(response.result); // ← ensure this line is there
        console.log(response.result, "respppooo");
      } else {
        setInjuryDatas(null); // explicitly mark as no data
      }
    } catch (error) {
      console.error("Error fetching injury data:", error);
    }
  };

  const [insuranceCarrierData, setinsuranceCarrierData] = useState<any>(null);
  ///fetchCaseheaderinfo

  useEffect(() => {
    if (injuryData.length > 0) {
      setIsAddingMoreInjury(true);
    }
  }, [injuryData]);
  useEffect(() => {
    if (userData && caseSubjectID) {
      fetchInjuryDetails();
    }
  }, [userData, selectedPartsObject]);
  const currentInjuryTypeLabel = InjuryTypeOptions.find(
    (opt) => Number(opt.value) === formData.injuryTypeId,
  )?.label;

  const handleSubmit = async () => {
    try {
      if (!isChanged) return;

      let validationMessages: string[] = [];

      // Required Field Validations

      if (!formData.injuryTypeId) {
        validationMessages.push("Injury Type is mandatory.");
      }
      if (!formData.insuranceCarrierId && !insuranceCarrierID) {
        validationMessages.push("Plz Select Insurance Carrier.");
      }
      if (currentInjuryTypeLabel === "Specific" && !formData.dateOfIncident) {
        validationMessages.push("Date of Incident is mandatory.");
      } else if (formData.injuryTypeId === 134) {
        if (!dateRange[0] || !dateRange[1]) {
          validationMessages.push("Both Start and End Dates are mandatory.");
        }
      }

      if (isAddingMoreInjury && !formData.claimNumber.trim()) {
        validationMessages.push("Claim Number is mandatory.");
      }

      const caseInjuryId = formData.caseSubjectInjuryID ?? null;
      const isDuplicateClaim = injuryData.some(
        (injury) =>
          injury.claimNumber.trim() === formData.claimNumber.trim() &&
          injury.caseSubjectInjuryID !== caseInjuryId,
      );

      // if (isDuplicateClaim) {
      //   validationMessages.push(
      //     "Duplicate Claim Number detected. Please use a unique Claim Number."
      //   );
      // }

      // if (!formData.bodyPartsAffected?.trim()) {
      //   validationMessages.push(
      //     "At least one affected body part must be selected."
      //   );
      // }

      // Date Validations
      const today = new Date().toISOString().split("T")[0];
      if (formData.dateOfIncident && formData.dateOfIncident > today) {
        validationMessages.push(
          "Date of the incident cannot be in the future.",
        );
      }
      if (dateRange[0] && dateRange[0].toISOString().split("T")[0] > today) {
        validationMessages.push("Start Date cannot be in the future.");
      }
      if (dateRange[1] && dateRange[1].toISOString().split("T")[0] > today) {
        validationMessages.push("End Date cannot be in the future.");
      }

      // Character Limits
      if (formData.injuryDetails?.length > 500) {
        validationMessages.push("Injury Details cannot exceed 500 characters.");
      }
      if (formData.additionalComments?.length > 1000) {
        validationMessages.push(
          "Additional Comments cannot exceed 1000 characters.",
        );
      }

      // Show validation errors
      if (validationMessages.length > 0) {
        setSnackbarMessage(validationMessages.join("\n"));
        setError("error");
        setSnackbarOpen(true);
        return;
      }

      const isUpdate = formData.caseSubjectInjuryID != null;

      const existingPrimaryInjury = injuryData?.find(
        (injury) =>
          injury.isPrimaryInjury === 1 &&
          injury.caseSubjectInjuryID !== formData.caseSubjectInjuryID,
      );

      // if (formData.isMainInjury && existingPrimaryInjury) {
      //   setSnackbarMessage(
      //     "Only one injury can be marked as Primary for billing."
      //   );
      //   setError("error");
      //   setSnackbarOpen(true);
      //   return; // Stop the submission
      // }

      //  Check if there is at least one primary injury (excluding the current form if it's not saved yet)
      const otherPrimaryInjuryExists = injuryData?.some(
        (injury) =>
          injury.isPrimaryInjury === 1 &&
          injury.caseSubjectInjuryID !== formData.caseSubjectInjuryID,
      );

      // CASE 1: If editing and trying to uncheck primary, but no other primary exists
      if (!formData.isMainInjury && !otherPrimaryInjuryExists) {
        setSnackbarMessage(
          "At least one injury should be marked as Primary for billing.",
        );
        setError("error");
        setSnackbarOpen(true);
        return; // Stop the submission
      }

      const payload = {
        caseSubjectID: formData.caseSubjectID || caseSubjectId,
        caseInfoID: formData.caseInfoID || caseInfoID,
        claimNumber: formData.claimNumber.trim() || claimnumber,
        injuryTypeId: formData.injuryTypeId
          ? Number(formData.injuryTypeId)
          : null,
        severityOfInjuryId: formData.severityOfInjuryId
          ? Number(formData.severityOfInjuryId)
          : null,
        natureOfInjuryId: Array.isArray(formData.natureOfInjuryId)
          ? formData.natureOfInjuryId.map(Number).join(",")
          : formData.natureOfInjuryId || "",
        // insuranceCarrierId: insuranceCarrierIDs
        //   ? insuranceCarrierIDs.join(",")
        //   : insuranceCarrierIDs,
        insuranceCarrierId: formData.insuranceCarrierId
          ? Number(formData.insuranceCarrierId)
          : insuranceCarrierID,
        qmeDoctorContactId: formData.qmeDoctorContactId
          ? Number(formData.qmeDoctorContactId)
          : qmeDoctorContactId,
        dateOfIncident: formattedDateTime(formData.dateOfIncident) || null,
        doictStartDate: dateRange[0]
          ? formattedDateTime(dateRange[0])
          : formattedDateTime(formData.doictStartDate) || null,
        doictEndDate: dateRange[1]
          ? formattedDateTime(dateRange[1])
          : formattedDateTime(formData.doictEndDate) || null,

        injuryDetails: formData.injuryDetails?.trim() || "",
        additionalComments: formData.additionalComments?.trim() || "",
        bodyPartsAffected: formData.bodyPartsAffected || "",
        additionalBodyPartsAffected:
          formData.additionalBodyPartsAffected?.trim() || "",
        isPrimaryInjury: formData.isMainInjury ? 1 : 0,
        createdBy: formData.createdBy || loggedInUserid || 0,
      };

      // Submit data
      let response;
      if (isUpdate) {
        response = await updateInjuryDetails(
          formData.caseSubjectInjuryID,
          payload,
        );
      } else {
        response = await AddInjury(payload);
      }

      if (response?.isSuccess) {
        const newId = response.result;
        if (!isUpdate && newId) {
          setFormData((prev) => ({
            ...prev,
            caseSubjectInjuryID: newId,
          }));
        }

        setflagSave(true);
        setSnackbarMessage(
          isUpdate
            ? "Injury updated successfully!"
            : "Injury added successfully!",
        );
        setError("success");
        setSnackbarOpen(true);
        if (!isUpdate && !isInjuryAvailable) {
          dispatch(setInjuryAvailable(true));
        }
        dispatchNew(fetchCaseStages(caseInfoID));

        setFormData({
          caseSubjectInjuryID: undefined,
          caseSubjectID: caseSubjectID ? caseSubjectID : caseSubjectId,
          caseInfoID: caseInfoID,
          injuryTypeId: 0,
          dateOfIncident: "",
          doictStartDate: "",
          doictEndDate: "",
          claimNumber: "",
          severityOfInjuryId: 0,
          isMainInjury: false,
          natureOfInjuryId: [], // Reset to an empty array
          insuranceCarrierId: 0,
          qmeDoctorContactId: 0,
          injuryDetails: "",
          additionalComments: "",
          bodyPartsAffected: "",
          additionalBodyPartsAffected: "",
          createdBy: 0,
        });
        const defaultInjuryType = InjuryTypeOptions.find(
          (opt) => opt.label === "Specific",
        );

        if (defaultInjuryType) {
          setFormData((prev) => ({
            ...prev,
            injuryTypeId: Number(defaultInjuryType.value), // ✅ Ensure number
          }));
        }

        // fetchInjuryDetails();
        setTimeout(() => {
          onTabChange();
          fetchInjuryDetails();
        }, 1000);

        initialFormRef.current = {
          ...formData,
          ...(newId ? { caseSubjectInjuryID: newId } : {}),
        };
        setIsChanged(false);
      } else {
        setSnackbarMessage("Failed to save injury. Please try again.");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      console.error("Error saving injury:", error.response?.data || error);
      setSnackbarMessage("Failed to save injury. Please try again.");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const [action, setAction] = useState<string | null>(null);

  const handleMultiSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    name: string,
    values: (string | number)[],
  ) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: values,
    }));
  };

  const injuryTypeMap: Record<number, string> = InjuryTypeOptions.reduce(
    (acc, option) => {
      acc[Number(option.value)] = option.label;
      return acc;
    },
    {} as Record<number, string>,
  );

  const severityMap: Record<number, string> = saverityOfInjuryOptions.reduce(
    (acc, option) => {
      acc[Number(option.value)] = option.label;
      return acc;
    },
    {} as Record<number, string>,
  );

  // ✅ Added caseSubjectID to dependencies

  ////////////////////////Fetch Subject////////////////
  const [caseSubjectID1, setcaseSubjectID] = useState<number | null>(null);
  useEffect(() => {
    const getCaseSubject = async () => {
      try {
        if (caseInfoID) {
          const subjectInfo = await fetchSubjectInfo(caseInfoID);

          if (subjectInfo?.caseSubjectID) {
            setcaseSubjectID(subjectInfo.caseSubjectID);
          }
        }
      } catch (error) {
        console.error("Error fetching subject info:", error);
      }
    };

    getCaseSubject();
  }, [caseInfoID]); // Runs when `caseid` changes
  /////////////////////////////Fetch Dropdown data///////////////////////////////

  const handleCloseLogDrawer = () => {
    setShowLogDrawer(false);
    setAction("");
  };

  const handleCancel = () => {
    if (selectedRowData && initialFormRef.current) {
      // Reset form data using initial values from initialFormRef
      const savedForm = initialFormRef.current;

      setFormData({
        caseSubjectInjuryID: savedForm.caseSubjectInjuryID,
        caseSubjectID: savedForm.caseSubjectID,
        caseInfoID: savedForm.caseInfoID,
        injuryTypeId: savedForm.injuryTypeId,
        dateOfIncident: savedForm.dateOfIncident,
        doictStartDate: savedForm.doictStartDate,
        doictEndDate: savedForm.doictEndDate,
        claimNumber: savedForm.claimNumber,
        severityOfInjuryId: savedForm.severityOfInjuryId,
        isMainInjury: savedForm.isMainInjury ?? false,
        natureOfInjuryId: savedForm.natureOfInjuryId, // Make sure it's an array
        ////////////// insurance Carrier code here
        insuranceCarrierId: savedForm.insuranceCarrierId,
        qmeDoctorContactId: savedForm.qmeDoctorContactId,
        injuryDetails: savedForm.injuryDetails,
        additionalComments: savedForm.additionalComments,
        bodyPartsAffected: savedForm.bodyPartsAffected,
        additionalBodyPartsAffected: savedForm.additionalBodyPartsAffected,
        createdBy: savedForm.createdBy,
      });
    } else {
      // Reset to initial form state if there's no selectedRowData
      setFormData({
        caseSubjectInjuryID: undefined,
        caseSubjectID: caseSubjectID ? caseSubjectID : caseSubjectId,
        caseInfoID: caseInfoID,
        injuryTypeId: 0,
        dateOfIncident: "",
        doictStartDate: "",
        doictEndDate: "",
        claimNumber: "",
        severityOfInjuryId: 0,
        isMainInjury: false,
        natureOfInjuryId: [], // Reset to an empty array
        insuranceCarrierId: 0,
        qmeDoctorContactId: 0,
        injuryDetails: "",
        additionalComments: "",
        bodyPartsAffected: "",
        additionalBodyPartsAffected: "",
        createdBy: 0,
      });
    }

    setDateRange([null, null]);
    setIsChanged(false);
  };
  useEffect(() => {
    if (!selectedRowData) {
      setFormData((prev) => ({
        ...prev,
        isMainInjury: !isAddingMoreInjury, // ← sets default checkbox status
      }));
    }
  }, [isAddingMoreInjury, selectedRowData]);

  const [injuryKey, setinjuryKey] = useState<string | null>("0");

  const injuryAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={injuryKey}
      onSelect={(key) => setinjuryKey(key as string)}
    />
  );

  const [injurydetailKey, setinjurydetailKey] = useState<string | null>("0");

  const handleAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (injurydetailKey === key) {
      return; // do nothing
    }
    setinjurydetailKey(key || "0");
  };

  const injurydetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={injurydetailKey}
      onSelect={handleAccordionSelect}
    />
  );
  const isDisabled = !isChanged || view_Case || isStageNonEditable;
  const [injurybodyKey, setinjurybodyKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (injurydetailKey === key) {
      return; // do nothing
    }
    setinjurybodyKey(key || "0");
  };

  const injurybodyAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={injurybodyKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  useEffect(() => {
    if (!formData.injuryTypeId && InjuryTypeOptions.length > 0) {
      const specificOption = InjuryTypeOptions.find(
        (opt) => opt.label === "Specific",
      );

      if (specificOption) {
        handleDropdownChange("injuryTypeId", specificOption.value);
      }
    }
  }, [InjuryTypeOptions]);

  return (
    <>
      <div id="injuryForm" className="mb-5">
        {/* <Loader isLoading={loading} /> */}
        {injuryAccordion([
          {
            title: "Injury Details",
            content: (
              <>
                <Row className="mb-3">
                  <Col xs={6} className="InjurySubAccord">
                    {injurydetailAccordion([
                      {
                        title: "Details",
                        content: (
                          <>
                            <Row className="mb-3">
                              <Col
                                xs={6}
                                className="selection_dropdown adj_label_lt mt-2"
                              >
                                <div>
                                  <SearchableSingleSelectDropdown
                                    label="Injury Type"
                                    name="injuryTypeId"
                                    options={InjuryTypeOptions}
                                    value={formData.injuryTypeId} // number like 133
                                    onChange={(event) =>
                                      handleDropdownChange(
                                        event.target.name,
                                        Number(event.target.value),
                                      )
                                    }
                                    required={true}
                                    disabled={view_Case || isStageNonEditable}
                                  />
                                </div>
                              </Col>

                              {currentInjuryTypeLabel === "Specific" ? ( // Assuming 1 = "Specific"
                                <Col xs={6} className="mb-2">
                                  <FloatingLabelDatepicker
                                    label="Date of Incident"
                                    name="dateOfIncident"
                                    value={
                                      formData.dateOfIncident
                                        ? new Date(formData.dateOfIncident)
                                        : null
                                    }
                                    maxDate={today} // Prevent future dates
                                    onChange={handleDateChange}
                                    required
                                    dateFormat="MM/dd/yyyy"
                                    disabled={view_Case || isStageNonEditable}
                                  />
                                </Col>
                              ) : currentInjuryTypeLabel ===
                                "Continious Trauma (CT)" ? ( // Assuming 2 = "CT"
                                <Col
                                  xs={6}
                                  className="mb-2 customDrodownControlDAtepicker"
                                >
                                  <DateRangePicker
                                    label="Select Start /  End Date"
                                    startDate={dateRange[0] ?? undefined}
                                    endDate={dateRange[1] ?? undefined}
                                    onChange={(newRange) =>
                                      setDateRange(newRange)
                                    }
                                    maxDate={new Date()} // Restricts future dates
                                    required
                                    disabled={view_Case || isStageNonEditable}
                                  />
                                </Col>
                              ) : null}
                            </Row>

                            <Row className="mb-3">
                              <Col xs={6}>
                                <TextInput
                                  label={`Claim No`}
                                  name="claimNumber"
                                  value={
                                    !isAddingMoreInjury
                                      ? claimnumber
                                      : formData.claimNumber
                                  }
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      claimNumber: e.target.value,
                                    })
                                  }
                                  disabled={
                                    !isAddingMoreInjury ||
                                    view_Case ||
                                    isStageNonEditable
                                  } // Enable only when adding more injury
                                  maxLength={50}
                                  required={true}
                                />
                              </Col>

                              <Col xs={6} className="d-flex align-items-center">
                                <label
                                  className="form-check-label me-2 fw-medium"
                                  htmlFor="isMainInjury"
                                >
                                  Primary For Billing
                                </label>
                                <div className="form-check d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="isMainInjury"
                                    name="isMainInjury"
                                    checked={formData.isMainInjury}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        isMainInjury: e.target.checked,
                                      })
                                    }
                                    style={{ cursor: "pointer" }}
                                    disabled={
                                      view_Case ||
                                      isStageNonEditable ||
                                      !isAddingMoreInjury
                                    }
                                  />
                                  {/* {formData.isMainInjury && (
                                    <span className="ms-2">Yes</span>
                                  )} */}
                                  <span className="ms-2">
                                    {formData.isMainInjury ? "Yes" : "No"}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col
                                xs={12}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableSingleSelectDropdown
                                  label="QME Doctor"
                                  name="qmeDoctorContactId"
                                  options={QMEDoctorOptions}
                                  value={
                                    Number(formData.qmeDoctorContactId) ||
                                    qmeDoctorContactId
                                  }
                                  onChange={(event) =>
                                    handleDropdownChange(
                                      event.target.name,
                                      Number(event.target.value),
                                    )
                                  }
                                  required={true}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col
                                xs={12}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableSingleSelectDropdown
                                  label="Insurance Carrier"
                                  name="insuranceCarrierId"
                                  options={insuranceOptions}
                                  value={
                                    Number(formData.insuranceCarrierId) ||
                                    insuranceCarrierID
                                  }
                                  onChange={(event) =>
                                    handleDropdownChange(
                                      event.target.name,
                                      Number(event.target.value),
                                    )
                                  }
                                  required={true}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col
                                xs={12}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableSingleSelectDropdown
                                  label="Severity of Injury"
                                  name="severityOfInjuryId"
                                  options={saverityOfInjuryOptions}
                                  value={
                                    Number(formData.severityOfInjuryId) || ""
                                  } // ✅ Normalize value
                                  onChange={(event) =>
                                    handleDropdownChange(
                                      event.target.name,
                                      Number(event.target.value), // ✅ Ensure value is numeric
                                    )
                                  }
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col
                                xs={12}
                                className="selection_dropdown adj_label_lt"
                              >
                                <SearchableMultiSelectDropdown
                                  label="Nature of Injury"
                                  name="natureOfInjuryId"
                                  options={natureOfInjuryOptions}
                                  values={formData.natureOfInjuryId || []} // 🛠️ Use array directly
                                  onChange={handleMultiSelectChange}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col xs={12}>
                                <MultilineTextBox
                                  //value={selectedParts.join(", ")} // Join selected body parts into a single string
                                  value={formData.bodyPartsAffected}
                                  label="Click on body parts to select"
                                  name="bodyPartsAffected"
                                  // required
                                  disabled // Prevent manual edits if necessary
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col xs={12}>
                                <TextInput
                                  label="Additional Body Part Affected"
                                  name="additionalBodyPartsAffected"
                                  value={formData.additionalBodyPartsAffected} // ✅ Bind Value
                                  onChange={handleInputChange}
                                  maxLength={1000}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col xs={12}>
                                <TextInput
                                  label="Injury Details"
                                  name="injuryDetails"
                                  value={formData.injuryDetails}
                                  onChange={handleInputChange}
                                  maxLength={1000}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col xs={12}>
                                <TextInput
                                  label="Additional Comments"
                                  name="additionalComments"
                                  value={formData.additionalComments} // ✅ Bind Value
                                  onChange={handleInputChange}
                                  maxLength={1000}
                                  disabled={view_Case || isStageNonEditable}
                                />
                              </Col>
                            </Row>
                          </>
                        ),
                      },
                    ])}
                  </Col>

                  {/* Right Side - Human Body Image */}
                  <Col xs={6} className="InjurySubAccord">
                    {injurybodyAccordion([
                      {
                        title: "Select Affected Body Part",
                        content: (
                          <>
                            {/* <StyledDiv> */}
                            {/* <BodyComponent
                onChange={handleBodyPartChange}
                partsInput={selectedPartsObject}
              /> */}
                            {/* </StyledDiv> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {gender === "Male" ||
                                gender === "Non-Binary" ||
                                gender === "Prefer Not to Say" ? (
                                <div
                                  // className={`body-view ${
                                  //   activeView === "front" ? "active" : ""
                                  // }`}
                                  onClick={() => setActiveView("front")}
                                  style={{
                                    position: "relative",
                                    // width: '300px',

                                    // border: activeView === "front" ? "3px solid blue" : "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={"/Male_front.png"}
                                    style={{
                                      height: "490px",
                                    }}
                                    alt={
                                      gender === "Male" ||
                                        gender === "Non-Binary" ||
                                        gender === "Prefer Not to Say"
                                        ? "Male Front View"
                                        : "Female Front View"
                                    }
                                    className="full-body-image"
                                  />

                                  <svg
                                    viewBox="0 87 200 275"
                                    className="full-body-svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      top: "0px",
                                      width: "110%",
                                      height: "112%",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    {/* Head Shape */}

                                    <polygon
                                      points="70,23,70,18,71,13,73,10,77,7,81,4,85,3,91,4,94,4,97,6,101,7,103,11,104,15,105,19,106,22"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Head-Front",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Head-Front",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Head-Front", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Eye Shape */}
                                    <polygon
                                      points="70,24,70,27,71,29,73,29,75,29,77,31,81,31,85,30,87,27,88,26,89,28,90,29,94,30,98,31,99,30,101,29,103,28,105,26,105,23"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Eye",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Eye",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Eye", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Nose Shape */}
                                    <polygon
                                      points="88,28,85,30,83,32,83,34,82,36,85,37,88,37,91,37,94,35,93,32,88,27"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Nose",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Nose",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        if (!isDisabled) {
                                          e.stopPropagation(); // Prevent event bubbling
                                          handleSelect("Nose", "front");
                                        }
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Ears */}
                                    <polygon
                                      points="74,30,71,30,69,29,68,29,68,32,69,34,69,35,71,38,74,39,75,32"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Ear",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Ear",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Ear", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Ears */}
                                    <polygon
                                      points="105,26,107,26,107,28,108,29,108,31,108,33,107,35,106,37,105,39,103,40,102,34,103,26"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Ear",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Ear",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Ear", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Chick */}
                                    <polygon
                                      points="95,34,93,31,96,32,98,32,101,30,102,32,101,35,101,38,102,40,102,43,98,43,96,39,93,37,94,34"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chick",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chick",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Chick", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Chick */}
                                    <polygon
                                      points="76,32,82,32,81,35,81,38,79,42,78,45,76,46,75,43,75,39,75,35"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chick",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chick",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Chick", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Mouth  */}
                                    <polygon
                                      points="92,38,95,40,97,43,98,46,96,48,91,50,84,50,78,48,78,44,81,40,82,38"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Mouth",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Mouth",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Mouth", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Front Neck  */}
                                    <polygon
                                      points="74,54,85,74,88,78,92,74,102,55,102,45,94,50,85,52,80,51,75,45,74,53"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Front Neck",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Front Neck",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Front Neck", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Shoulder  */}
                                    <polygon
                                      points="145,112,140,107,132,95,122,83,114,79,107,76,94,74,97,68,100,62,104,55,109,58,114,61,120,66,125,69,131,70,136,73,141,79,144,88,145,101"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Shoulder",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Upper Hand  */}
                                    <polygon
                                      points="130,95,127,101,125,108,125,114,125,121,126,127,128,133,130,138,133,143,138,147,141,150,143,154,146,150,147,143,149,133,145,113,137,105,133,99"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Upper Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*Left Front Lower Hand  */}
                                    <polygon
                                      points="132,143,137,148,141,155,144,155,147,150,149,142,150,135,156,146,157,154,157,167,159,179,160,190,161,197,150,201,147,196,143,183,137,172,134,160"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Lower Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Palm  */}
                                    <polygon
                                      points="148,203,153,201,157,200,162,198,168,202,173,209,176,214,178,217,174,218,169,213,168,218,169,225,168,233,169,240,165,242,160,242,156,239,151,235,149,232,148,219,147,208"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Palm",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Palm",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Palm",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Shoulder  */}
                                    <polygon
                                      points="33,110,37,107,41,102,44,97,47,91,52,88,59,83,67,79,72,76,78,74,83,74,79,67,76,62,73,55,66,59,60,63,55,67,52,69,45,71,40,73,36,79,34,87,33,97"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Shoulder",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Upper Hand  */}
                                    <polygon
                                      points="33,112,37,109,40,105,44,100,46,95,49,92,50,97,52,102,52,107,52,113,52,120,50,124,50,130,47,137,45,142,34,155,29,133,30,119"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Upper Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Lower Hand  */}
                                    <polygon
                                      points="28,134,29,140,30,146,33,157,37,155,40,150,46,143,45,150,45,156,43,165,39,174,37,181,34,190,29,201,15,196,19,186,19,176,19,163,21,151,24,143"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Lower Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Palm  */}
                                    <polygon
                                      points="14,197,18,199,22,201,27,203,30,204,30,215,29,221,29,226,29,231,27,234,23,235,23,241,19,243,15,243,10,242,9,221,9,213,6,217,3,212,6,207,10,201"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Palm",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Palm",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Palm",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Chest  */}
                                    <polygon
                                      points="93,75,90,80,90,86,89,94,90,107,90,114,92,118,98,121,104,124,108,128,113,127,117,122,123,115,124,107,127,100,130,95,123,87,115,81,106,77"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chest",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chest",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Chest", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Chest  */}
                                    <polygon
                                      points="84,75,87,80,88,84,88,102,87,114,82,118,73,124,71,128,61,123,54,111,54,104,52,98,50,92,57,86,69,80,78,76"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Chest", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Upper Stomach */}
                                    <polygon
                                      points="89,156,89,146,90,139,90,132,90,120,95,122,100,125,105,129,111,128,115,126,120,121,123,118,123,123,122,131,120,140,120,147,105,155"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Upper Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Upper Stomach */}
                                    <polygon
                                      points="54,124,54,116,56,121,62,126,68,130,73,128,77,125,82,122,86,119,89,118,88,156,76,156,72,156,59,143,58,138"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Lower Stomach */}
                                    <polygon
                                      points="91,158,98,157,103,157,108,155,112,153,117,150,120,149,122,157,122,164,117,169,111,176,104,183,97,192,89,200,89,179,89,165,89,159"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Lower Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Lower Stomach */}
                                    <polygon
                                      points="58,145,62,148,66,152,70,156,73,157,80,158,88,158,88,162,88,170,88,174,88,178,88,183,88,189,88,199,76,187,68,176,57,165,56,152"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Stomach"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Stomach"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Upper Leg */}
                                    <polygon
                                      points="89,202,94,197,98,192,103,186,111,178,117,171,122,165,123,169,124,175,129,197,129,217,130,236,129,249,126,259,123,268,121,275,117,272,114,265,111,270,107,277,103,281,99,279,95,271"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Upper Leg"))
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left_Upper Leg",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Upper Leg", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Knee */}
                                    <polygon
                                      points="95,276,97,279,99,281,102,283,104,281,107,278,110,273,113,267,116,272,119,276,121,278,121,282,121,286,121,290,121,295,110,311,106,311,99,295,98,286"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Knee", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Lower Leg */}
                                    <polygon
                                      points="121,297,118,303,114,308,112,311,108,312,104,310,99,297,97,301,97,305,96,307,94,316,94,323,95,327,97,331,98,335,99,352,99,361,99,368,100,376,101,374,103,373,106,373,108,374,112,377,112,366,114,360,117,353,121,336,123,325,123,309,121,307"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Lower Leg"))
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Lower Leg"))
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Lower Leg", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Feet */}
                                    <polygon
                                      points="99,380,101,377,102,374,105,374,108,376,111,377,112,380,116,384,123,392,126,395,124,397,119,398,111,399,107,398,103,396,98,392,97,383"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Feet",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Feet",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Feet", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Upper Leg */}
                                    <polygon
                                      points="55,168,59,171,63,175,67,179,72,185,77,192,82,197,86,201,88,205,86,212,87,231,84,246,83,261,82,271,81,276,79,280,75,281,71,275,66,264,62,260,61,266,61,272,59,276,55,271,52,262,50,250,48,240,47,221,49,201"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Upper Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Leg",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Lower Leg */}
                                    <polygon
                                      points="55,299,59,302,62,305,65,307,69,306,73,302,75,298,78,294,79,299,80,304,81,309,82,313,83,319,82,326,81,331,79,335,78,345,77,359,77,363,77,372,78,379,75,377,71,375,69,376,66,378,64,370,61,354,58,342,56,333,53,323,53,312"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Leg",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Feet */}
                                    <polygon
                                      points="65,380,68,378,71,376,74,379,76,380,78,380,78,384,79,388,79,392,79,393,77,393,74,396,72,398,66,398,60,398,54,397,51,395,56,391,60,387"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Feet",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Feet",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Feet", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />

                                    {/* Right Knee */}
                                    <polygon
                                      points="75,282,72,278,69,273,66,268,63,262,62,267,62,274,60,277,56,275,57,279,57,284,57,289,56,295,55,298,60,300,66,306,70,303,74,300,76,296,79,291,80,285,81,277,77,281"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Knee", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                  </svg>

                                  {/* </div> */}
                                </div>
                              ) : (
                                <div
                                  // className={`body-view ${
                                  //   activeView === "front" ? "active" : ""
                                  // }`}
                                  onClick={() => setActiveView("front")}
                                  style={{
                                    position: "relative",
                                    // width: '300px',
                                    // height: '600px',
                                    //border: activeView === "front" ? "3px solid blue" : "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={"/Female_front.png"}
                                    style={{
                                      height: "490px",
                                    }}
                                    alt="Female Body Front View"
                                    className="full-body-image"
                                  />

                                  <svg
                                    viewBox="0 87 200 275"
                                    className="full-body-svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      top: "0px",
                                      width: "110%",
                                      height: "113%",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    {/* Head Shape */}

                                    <polygon
                                      points="107,19,106,16,106,12,104,8,100,3,100,4,89,0,83,1,80,1,76,3,78,4,73,6,72,10,71,12,71,14,70,18,72,19"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "forehead",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "forehead",
                                        )
                                          ? "Red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("forehead", "frontfemale");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Eye Shape */}
                                    <polygon
                                      points="88,19,84,19,79,19,75,19,70,19,71,22,71,23,74,25,74,26,77,28,78,29,81,29,84,29,86,27,89,25,90,26,91,27,92,30,96,31,100,31,102,29,103,27,104,23,106,23,106,20,105,19,97,18,92,18"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Eye",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Eye",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Eye", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Nose Shape */}
                                    <polygon
                                      points="90,26,93,30,94,33,93,36,88,35,84,34,86,28"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Nose",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Nose",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Nose", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Ears */}
                                    <polygon
                                      points="105,23,103,26,103,30,103,31,102,35,103,37,106,35,108,31,108,27,107,23,106,22"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Ear",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Ear",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Ear", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Ears */}
                                    <polygon
                                      points="72,23,74,28,74,31,74,33,74,34,74,37,71,35,70,32,69,29,69,26"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Ear",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Ear",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Ear", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Chick */}
                                    <polygon
                                      points="84,30,82,34,82,35,80,37,79,41,78,44,75,40,74,36,75,28,78,30,83,30"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chick",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chick",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Chick", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Chick */}
                                    <polygon
                                      points="95,34,93,31,96,32,98,32,101,30,102,32,101,35,101,38,102,40,102,43,98,43,96,39,93,37,94,34"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chick",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Chick",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Chick", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Mouth  */}
                                    <polygon
                                      points="83,35,86,36,89,36,93,37,92,38,94,39,96,40,97,43,96,45,93,48,89,50,85,49,81,47,79,43,80,38"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Mouth",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Mouth",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Mouth", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Front Neck  */}
                                    <polygon
                                      points="76,43,81,48,85,50,88,51,91,50,94,46,97,43,100,44,100,50,101,54,101,56,89,74,75,57,77,54,78,50"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Front Neck",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Front Neck",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Front Neck", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Shoulder  */}
                                    <polygon
                                      points="41,103,45,99,47,94,49,88,52,86,57,83,61,80,67,75,72,72,78,72,86,73,75,57,72,59,68,62,66,63,62,65,58,66,53,67,49,69,46,72,43,76,41,83,41,92"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Shoulder",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Upper Hand  */}
                                    <polygon
                                      points="53,86,55,89,57,92,57,97,56,100,55,103,56,108,56,112,54,115,54,123,53,127,50,131,50,135,46,138,35,152,36,129,38,122,38,116,41,103,48,93,49,89"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Upper Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*Right Front Lower Hand  */}
                                    <polygon
                                      points="50,137,35,153,35,131,34,133,32,136,30,139,29,142,27,147,26,153,25,160,24,163,23,167,22,173,20,179,19,186,18,190,29,194,36,174,39,170,42,163,46,152,49,143"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Lower Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Front Palm  */}
                                    <polygon
                                      points="17,190,28,194,28,196,29,200,29,203,28,207,27,212,26,216,25,221,24,225,24,227,17,228,16,231,12,233,8,230,5,229,10,211,10,205,3,212,3,207,5,203,12,195"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Palm",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Front Palm",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Front Palm",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Shoulder  */}
                                    <polygon
                                      points="102,57,92,72,96,73,100,72,106,72,109,75,111,77,114,80,118,82,120,85,124,88,128,92,137,108,137,102,137,96,137,89,137,82,135,78,129,71,124,68,117,66,110,64,105,61"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Shoulder",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Upper Hand  */}
                                    <polygon
                                      points="137,109,131,99,129,94,124,88,123,90,122,93,122,96,121,101,121,107,122,111,122,116,122,120,123,126,126,129,141,148,144,131,140,120,139,112"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Upper Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Lower Hand  */}
                                    <polygon
                                      points="142,149,144,134,147,137,148,141,151,144,152,151,154,158,154,164,157,171,157,176,159,183,161,190,150,194,147,185,143,178,138,170,136,166,135,161,132,153,130,146,129,141,127,137,126,130"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Lower Hand",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Front Palm  */}
                                    <polygon
                                      points="151,195,161,191,164,194,167,195,171,198,174,202,177,206,179,209,177,211,171,207,171,211,174,221,175,228,172,231,167,233,161,233,158,229,154,229,152,210,152,201"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Palm",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Front Palm",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Front Palm",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Chest  */}
                                    <polygon
                                      points="88,74,82,73,76,73,70,74,67,77,63,80,58,84,55,87,57,90,58,92,58,97,56,100,56,102,56,106,57,110,57,113,59,116,62,121,65,125,70,128,77,130,82,129,87,128,88,127,88,114,88,103,88,93,89,81"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Chest", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Chest  */}
                                    <polygon
                                      points="89,75,93,74,98,73,102,72,106,74,109,76,113,81,116,83,120,85,123,88,122,91,121,96,121,99,121,105,121,110,121,113,119,116,117,120,114,124,108,128,104,131,97,129,92,129,89,127,89,107,89,89,89,80"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Chest",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Chest", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Upper Stomach */}
                                    <polygon
                                      points="88,128,84,129,81,131,77,131,73,131,67,128,65,126,61,121,59,117,59,120,59,124,60,127,61,131,62,135,62,139,62,142,63,145,72,156,77,157,82,157,88,158,88,152,88,145,88,138,88,133"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Upper Stomach */}
                                    <polygon
                                      points="89,128,91,130,95,130,99,131,102,132,104,132,105,131,109,129,112,126,115,122,119,117,118,121,118,126,116,131,116,135,116,138,117,141,116,145,112,149,108,153,105,155,100,157,96,157,89,157,89,147,88,141,89,135"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Upper Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Lower Stomach */}
                                    <polygon
                                      points="88,159,82,158,79,158,73,158,71,156,69,152,64,147,61,146,60,150,59,154,58,158,56,161,55,162,55,164,56,167,58,169,62,173,66,175,71,179,78,187,84,195,88,201,88,187,88,177,88,166"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Stomach",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Stomach",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Lower Stomach */}
                                    <polygon
                                      points="89,158,93,158,96,158,101,158,103,157,107,155,110,152,112,149,114,148,116,146,118,149,120,155,121,158,121,161,122,165,122,167,118,170,114,174,109,176,105,180,98,188,92,195,89,201,89,186,89,175,89,166"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Left Lower Stomach"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Left Lower Stomach"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Left Lower Stomach",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Upper Leg */}
                                    <polygon
                                      points="88,201,88,204,86,207,87,209,87,213,86,220,87,228,86,230,86,234,86,241,85,247,85,253,85,262,86,270,85,276,83,279,81,282,79,283,77,279,69,261,67,263,66,269,65,275,65,279,61,275,58,266,56,254,54,248,52,240,50,227,49,218,48,208,48,198,49,190,51,183,52,176,54,168,58,170,67,178,69,178,73,182,78,189,83,193"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Upper Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Leg",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Knee */}
                                    <polygon
                                      points="68,262,70,262,70,264,71,267,73,272,75,275,76,280,79,283,81,281,83,278,85,275,85,279,85,284,85,289,84,292,83,295,81,299,79,302,77,306,73,311,68,308,65,302,63,297,61,294,61,287,60,281,60,275,63,280,65,279,66,272"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Knee", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Lower Leg */}
                                    <polygon
                                      points="74,311,76,309,77,305,79,302,81,298,81,302,82,304,83,308,83,310,84,314,85,317,85,319,85,323,85,327,85,332,84,336,83,340,82,345,83,350,82,355,83,365,82,370,82,374,77,374,71,375,69,370,70,363,68,358,66,351,64,343,62,334,59,325,58,318,59,307,61,295,63,300,66,305,68,309,69,312"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Right Lower Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Leg",
                                          "front",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Feet */}
                                    <polygon
                                      points="84,374,79,375,75,376,72,375,70,376,71,379,64,390,61,391,60,395,63,397,65,399,81,399,82,395,85,389,83,384,84,379"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Feet",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Feet",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Feet", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Upper Leg */}
                                    <polygon
                                      points="89,202,89,204,91,204,91,205,91,208,90,211,90,216,90,220,90,226,91,233,92,242,93,250,93,258,93,266,93,273,93,280,99,284,101,280,103,274,108,261,111,263,110,269,113,277,115,277,118,276,118,273,119,269,120,263,122,257,124,251,124,245,125,240,127,234,128,228,129,220,130,215,129,194,128,188,126,182,125,174,124,170,123,166,120,170,113,175,110,176,108,179,103,184,98,189,95,193,92,197,90,202"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Upper Leg"))
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Upper Leg"))
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Upper Leg", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Lower Leg */}
                                    <polygon
                                      points="107,316,105,316,103,315,102,311,101,306,98,302,96,297,96,301,95,306,94,311,92,318,91,323,93,328,94,333,95,338,95,342,96,350,96,359,96,366,95,371,109,370,109,365,110,360,112,353,113,347,115,341,117,334,118,328,119,322,120,315,120,309,119,304,117,296,115,298,110,305,110,310"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Lower Leg"))
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(normalize("Left Lower Leg"))
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Lower Leg", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Feet */}
                                    <polygon
                                      points="95,371,102,372,108,370,108,373,108,376,109,380,109,382,110,386,116,394,116,395,114,398,111,399,99,399,96,398,95,396,94,390,94,386,95,380"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Feet",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Feet",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Feet", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />

                                    {/* Left Knee */}
                                    <polygon
                                      points="108,263,110,263,110,264,110,267,110,269,110,271,110,271,111,275,113,277,113,278,116,277,118,275,118,279,118,280,118,284,117,287,116,290,116,294,117,296,114,298,111,303,109,307,108,312,106,316,103,314,100,305,96,296,94,292,93,287,94,280,100,286,101,286,101,283,104,274,105,268"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Knee", "front");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                  </svg>
                                  {/* back of body */}
                                  {/* </div> */}
                                  {bodyParts.map((part) => (
                                    <div
                                      key={part.name}
                                      className={`clickable-area ${selectedParts.includes(part.name)
                                        ? "highlighted"
                                        : ""
                                        }`}
                                      style={{
                                        position: "absolute",
                                        left: `${part.coords.split(",")[0]}px`,
                                        top: `${part.coords.split(",")[1]}px`,
                                        width: "40px",
                                        height: "40px",
                                        background: selectedParts.includes(
                                          part.name,
                                        )
                                          ? "rgba(255, 0, 0, 0.7)" // Darker Red when selected
                                          : "transparent", // No color when not selected
                                        borderRadius: "50%",
                                        border: selectedParts.includes(
                                          part.name,
                                        )
                                          ? "2px solid red"
                                          : "none",
                                        cursor: "pointer",
                                        transition: "0.2s ease-in-out",
                                      }}
                                      onClick={() => setActiveView("front")}
                                    ></div>
                                  ))}
                                </div>
                              )}
                              {/* Back Side Of Bodyyy Div */}
                              {gender === "Male" ||
                                gender === "Non-Binary" ||
                                gender === "Prefer Not to Say" ? (
                                <div
                                  // className={`body-view ${
                                  //   activeView === "back" ? "active" : ""
                                  // }`}

                                  onClick={() => {
                                    setActiveView("front");
                                  }}
                                  style={{
                                    position: "relative",
                                    // width: '300px',
                                    // height: '600px',
                                    // border: activeView === "back" ? "3px solid blue" : "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={"/Male_back.png"}
                                    style={{
                                      height: "490px",
                                    }}
                                    alt="Back View"
                                    className="full-body-image"
                                  />
                                  <svg
                                    viewBox="0 0 200 490"
                                    className="full-body-svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      position: "absolute",
                                      left: "2px",
                                      top: "1px",

                                      height: "122%",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    <polygon
                                      points="70,15,73,11,76,7,79,5,82,4,87,4,91,4,96,5,99,8,101,12,104,18,105,23,107,26,107,30,106,34,105,39,101,40,95,37,91,34,85,33,79,33,76,34,76,38,75,41,72,39,67,34,67,27,69,25"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Head",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Head",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Head", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Neck */}
                                    <polygon
                                      points="73,42,77,40,77,36,82,35,87,35,92,36,96,38,98,40,102,40,102,43,101,46,100,51,87,47,75,52"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Neck",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Neck",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Neck", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Shoulder  */}
                                    <polygon
                                      points="88,49,94,50,99,51,102,54,113,62,120,66,123,68,129,70,133,71,138,75,142,82,143,90,144,98,143,105,135,94,129,91,120,85,106,75,98,70,88,64"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Shoulder",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Shoulder  */}
                                    <polygon
                                      points="87,49,87,62,84,66,71,73,61,79,54,84,44,90,36,98,31,102,31,89,34,78,40,71,53,66,64,62,67,58,74,53,82,50"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Shoulder",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*   Left Upper Back  */}
                                    <polygon
                                      points="87,64,86,136,73,128,62,120,50,110,49,106,50,101,47,97,47,89,55,84,72,73"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Upper Back", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*   Right Upper Back  */}
                                    <polygon
                                      points="88,65,87,136,91,134,95,129,101,126,106,124,112,120,118,116,123,111,123,108,123,103,124,98,126,93,126,89,115,81,103,74,94,69"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Back",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Left Lower Back   */}
                                    <polygon
                                      points="87,137,72,126,65,121,57,116,50,111,50,115,49,119,50,124,51,131,52,136,54,141,55,144,55,148,55,153,55,157,55,161,54,166,54,170,53,175,58,171,61,168,64,168,68,168,72,168,77,174,80,177,84,186,85,193,86,192,87,179,87,161,87,149"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Lower Back", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Right Lower Back   */}
                                    <polygon
                                      points="87,191,89,187,90,183,92,179,94,177,96,175,98,171,99,172,103,169,106,168,107,169,111,169,114,170,116,171,119,178,120,174,121,170,120,164,119,161,120,160,119,153,119,150,119,145,121,141,122,134,123,131,124,125,124,119,124,116,123,112,121,113,116,117,111,120,106,124,101,126,96,129,93,131,89,135,87,135,88,147,87,156,87,171"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Back",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Hip */}
                                    <polygon
                                      points="86,192,85,191,84,185,81,179,78,175,77,173,75,171,69,168,63,168,59,170,57,172,54,174,52,176,52,178,52,182,52,186,51,190,51,195,50,198,49,202,49,205,48,209,48,212,47,215,47,219,47,224,47,228,47,230,47,234,50,237,50,228,52,223,54,221,60,221,66,221,72,219,76,217,80,214,84,212,85,210,86,210,86,206,86,196"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Hip",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          " Left Hip",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Hip", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Hip */}
                                    <polygon
                                      points="119,175,118,174,115,171,111,170,107,169,102,169,98,171,95,176,91,179,91,180,89,186,88,190,87,193,88,195,86,197,87,200,87,202,87,205,87,208,88,211,91,212,93,214,96,215,99,217,101,217,104,218,107,219,112,220,116,220,119,221,121,224,123,227,128,233,128,232,128,228,128,221,126,213,124,206,123,199,121,193,121,188"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Hip",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Hip",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Hip", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*<Back Left Upper Leg*/}
                                    <polygon
                                      points="85,212,81,214,77,217,74,219,70,221,66,221,59,222,54,222,52,225,51,230,50,234,50,239,49,241,50,244,50,246,50,250,51,253,52,260,52,267,54,272,55,277,55,281,57,286,60,284,62,275,62,273,63,267,65,260,66,263,67,268,69,272,69,275,71,280,74,284,76,285,77,285,79,280,81,275,82,263,82,252,84,243,84,235,85,226"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Upper Leg",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Upper Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*<Back Right Upper Leg*/}
                                    <polygon
                                      points="89,212,92,215,95,216,97,217,101,218,105,220,110,220,111,221,114,221,120,223,119,225,123,228,126,233,127,232,129,236,129,248,128,255,128,260,128,262,127,267,126,271,125,276,125,278,126,283,122,283,120,280,118,277,115,269,114,261,113,260,112,262,112,266,110,269,109,272,108,275,108,279,108,285,107,288,103,284,101,274,99,268,99,261,96,253,93,244,91,229,90,222"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Upper Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Upper Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Left Back Knee */}
                                    <polygon
                                      points="65,262,64,265,63,269,63,272,62,275,62,277,60,280,60,283,58,287,56,283,55,286,55,287,56,290,58,292,60,294,61,295,63,299,64,302,65,307,67,313,69,315,71,310,72,302,71,297,72,295,73,296,74,296,76,296,79,293,79,290,79,288,81,285,81,278,79,277,75,283,74,284,70,281,68,273,66,267"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Back Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Back Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Back Knee",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Back Knee */}
                                    <polygon
                                      points="102,283,108,290,109,280,109,277,110,273,110,271,112,267,113,261,114,264,114,268,115,271,116,274,117,278,118,278,120,282,121,284,126,283,127,283,127,287,127,289,126,291,126,294,128,298,128,302,129,306,126,306,123,300,121,295,119,291,118,293,116,295,115,298,114,301,114,305,112,307,110,304,110,298,108,297,109,296,106,300,105,294"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Back Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Back Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Back Knee",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* <Back Left Lower Leg  */}
                                    <polygon
                                      points="79,291,75,297,72,296,72,297,71,301,72,306,72,308,71,310,70,314,68,316,67,312,64,308,63,302,61,299,60,296,58,294,57,294,57,297,56,300,56,304,53,308,53,311,53,314,53,318,53,321,53,325,54,328,54,331,55,335,55,339,56,342,58,345,58,347,58,351,59,354,60,359,62,364,63,368,63,372,64,375,68,375,72,374,76,373,78,374,77,366,78,360,78,353,79,347,78,342,79,337,80,334,82,330,81,322,80,314,77,310,78,304,78,300"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Lower Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Lower Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Lower Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Lower Leg  */}
                                    <polygon
                                      points="118,293,120,295,122,300,123,302,124,305,126,308,129,306,129,310,130,314,130,319,130,324,130,329,130,334,130,338,129,343,129,347,127,350,128,354,128,360,127,364,126,372,126,376,122,375,116,374,112,374,111,368,110,361,109,355,109,347,108,342,107,336,106,333,104,330,102,327,102,324,102,319,103,313,104,306,106,301,108,297,109,300,109,306,110,306,110,309,114,307,115,302,116,298"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Leg",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Leg",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Lower Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />

                                    {/* Back Left Ankle Heel */}
                                    <polygon
                                      points="64,375,67,376,70,375,73,375,73,375,76,374,78,374,79,377,80,379,80,381,80,383,80,385,80,388,80,391,81,395,80,398,78,399,77,399,72,400,66,399,60,398,55,397,49,397,46,396,43,394,44,390,47,390,51,389,56,385,62,380"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Ankle Heel",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Ankle Heel",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Ankle Heel",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Ankle Heel */}
                                    <polygon
                                      points="111,375,114,375,117,376,120,376,123,376,126,376,127,377,129,379,131,381,133,382,135,384,137,386,141,388,144,389,146,389,147,390,148,392,149,394,147,396,143,397,137,397,133,398,127,398,123,399,120,399,115,399,111,398,109,395,109,392,111,387,112,384,112,379"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Ankle Heel",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Ankle Heel",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Ankle Heel",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Upper Hand */}
                                    <polygon
                                      points="32,103,37,97,42,92,47,90,46,95,47,98,48,100,49,104,49,107,48,112,48,118,47,123,46,127,44,132,40,140,37,133,35,124,30,124,25,127,28,111,29,107"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Upper Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Upper Hand */}
                                    <polygon
                                      points="127,91,133,94,137,99,141,105,144,105,146,109,147,113,148,119,150,138,147,129,138,120,136,124,137,128,138,140,134,140,130,133,125,124,124,115,123,108,124,99"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Upper Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Left Elbow */}
                                    <polygon
                                      points="36,129,33,125,31,125,27,127,25,129,24,133,25,136,24,144,22,150,22,158,25,168,27,161,31,154,34,146,36,139,37,135"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Elbow",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Elbow",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Left Elbow", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Elbow */}
                                    <polygon
                                      points="138,122,142,125,144,128,146,131,149,135,150,139,150,143,150,150,151,155,150,165,146,162,141,147,138,141"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Elbow",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Elbow",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Elbow",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Lower Hand */}
                                    <polygon
                                      points="40,140,38,137,37,143,34,148,32,154,29,161,27,166,23,165,21,158,21,152,22,146,24,140,24,134,19,140,17,148,16,156,15,164,14,170,13,176,13,184,12,189,12,195,15,198,22,197,23,191,27,183,31,175,36,166,38,154,39,147"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Lower Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Lower Hand */}
                                    <polygon
                                      points="150,135,150,141,151,147,151,152,153,156,152,161,151,166,147,165,144,159,142,152,139,145,137,141,133,141,134,146,135,152,136,157,137,161,139,166,141,172,144,176,146,180,147,184,148,188,151,191,151,198,158,198,163,198,160,187,160,182,160,175,159,168,159,158,157,149,154,140,152,135"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Lower Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Plam */}
                                    <polygon
                                      points="11,197,14,199,19,199,21,199,23,197,25,199,27,203,27,208,28,214,28,218,24,219,22,215,20,211,19,216,19,218,21,222,25,223,27,224,27,229,23,230,17,228,11,221,9,216,11,209"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Plam",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Plam",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Left Plam", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Plam */}
                                    <polygon
                                      points="150,199,147,202,146,205,146,208,146,211,145,213,145,217,145,219,147,220,150,217,151,212,153,212,154,216,153,219,149,221,146,221,146,225,146,228,148,231,154,230,159,228,164,224,165,219,164,208,164,202,163,198"
                                      fill={
                                        selectedParts.includes(
                                          "Back Right Plam",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        selectedParts.includes(
                                          "Back Right Plam",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Right Plam", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                  </svg>
                                </div>
                              ) : (
                                <div
                                  className={`body-view ${activeView === "back" ? "active" : ""
                                    }`}
                                  onClick={() => setActiveView("back")}
                                  style={{
                                    position: "relative",
                                    // width: '300px',
                                    // height: '600px',
                                    // border: activeView === "back" ? "3px solid blue" : "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={"/Female_back.png"}
                                    style={{
                                      height: "490px",
                                    }}
                                    alt="Back View"
                                    className="full-body-image"
                                  />
                                  <svg
                                    viewBox="0 0 200 490"
                                    className="full-body-svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      position: "absolute",
                                      left: "2px",
                                      top: "0px",

                                      height: "122%",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    <polygon
                                      points="88,43,101,37,103,36,106,31,108,24,105,23,106,19,104,13,102,6,91,-1,81,1,76,3,73,7,71,9,69,15,70,23,67,24,66,25,67,29,70,34,75,37"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Head",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Head",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Head", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Neck */}
                                    <polygon
                                      points="87,44,90,43,92,41,95,40,99,38,98,42,98,47,98,51,98,54,94,58,87,64,80,59,76,56,75,50,76,45,75,42,73,37,80,40,83,43"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Neck",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Neck",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Neck", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Shoulder  */}
                                    <polygon
                                      points="136,101,130,95,127,90,121,85,115,81,109,80,105,81,98,75,88,65,99,54,102,58,103,60,107,61,111,64,114,66,119,66,123,67,127,69,130,72,133,76,135,81,136,87"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Shoulder",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Shoulder  */}
                                    <polygon
                                      points="75,56,70,60,65,64,61,66,57,66,53,67,48,69,45,72,42,76,41,81,41,88,40,94,40,100,45,95,52,85,56,83,61,81,66,81,69,81,72,80,85,64,79,59"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Shoulder",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Shoulder",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Shoulder",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*   Left Upper Back  */}
                                    <polygon
                                      points="87,65,83,68,73,81,71,82,61,81,54,84,55,87,55,89,57,99,60,102,66,105,73,106,77,106,79,109,87,116,87,106,87,95,87,79"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Upper Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Upper Back", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*   Right Upper Back  */}
                                    <polygon
                                      points="88,66,103,81,105,82,108,82,110,81,112,81,115,82,119,84,119,87,120,91,120,96,119,99,116,101,111,104,107,106,102,106,99,106,95,107,93,109,92,110,90,114,88,115,87,107,88,94,88,84,88,77"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Upper Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Upper Back",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Left Lower Back   */}
                                    <polygon
                                      points="87,117,83,113,80,111,77,108,76,107,73,107,70,107,67,106,65,106,59,103,57,101,56,106,56,112,57,116,58,121,59,128,61,135,61,141,60,146,59,151,57,156,52,169,55,166,57,163,61,161,65,160,71,160,74,161,76,163,79,166,82,169,84,172,86,176,87,181,88,186,88,168,87,150,87,138,88,126"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Left Lower Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Left Lower Back", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Right Lower Back   */}
                                    <polygon
                                      points="88,116,90,114,92,112,95,109,97,108,101,107,106,107,109,105,113,103,118,100,120,103,120,106,120,110,119,112,118,116,117,122,117,127,116,133,115,135,114,144,117,147,118,151,119,156,123,170,121,166,117,163,113,162,108,160,103,161,98,163,95,167,93,171,91,175,89,180,89,171,88,160,88,147,88,135,88,125"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Back",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Lower Back",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Right Lower Back",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Left Hip */}
                                    {/* <polygon
                        points="88,181,85,176,83,172,79,168,76,165,72,162,68,161,64,161,60,163,55,166,53,170,51,173,50,179,49,185,49,190,47,194,47,200,47,213,48,219,49,224,53,220,56,215,62,213,70,212,77,209,81,207,86,202,87,197"
                        fill={
                          formData.bodyPartsAffected.includes("Left Hip")
                            ? "rgba(255, 0, 0, 0.7)"
                            : "transparent"
                        }
                        stroke={
                          formData.bodyPartsAffected.includes(" Left Hip")
                            ? "red"
                            : "black"
                        }
                        strokeWidth="1"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event bubbling
                          handleSelect("Left Hip", "back");
                        }}
                        style={{ cursor: "pointer", pointerEvents: "all" }}
                      /> */}
                                    <polygon
                                      points="88,181,85,176,83,172,79,168,76,165,72,162,68,161,64,161,60,163,55,166,53,170,51,173,50,179,49,185,49,190,47,194,47,200,47,213,48,219,49,224,53,220,56,215,62,213,70,212,77,209,81,207,86,202,87,197"
                                      fill={
                                        selectedParts.includes("Left Hip")
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        selectedParts.includes("Left Hip")
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSelect("Left Hip", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Right Hip */}
                                    <polygon
                                      points="89,181,90,178,91,175,92,172,94,169,96,166,100,163,103,161,107,161,112,162,116,164,119,166,121,169,123,171,124,174,125,179,126,183,127,188,128,195,128,214,127,223,123,220,118,215,114,213,109,212,105,212,100,211,96,209,91,204,89,198"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Right Hip",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Right Hip",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Right Hip", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*<Back Left Upper Leg*/}
                                    <polygon
                                      points="85,205,84,208,86,212,86,215,85,218,87,223,86,228,86,232,85,240,85,248,84,258,84,268,84,277,84,276,82,290,72,271,67,277,61,288,60,282,59,274,56,265,54,254,53,246,50,232,50,224,53,221,56,219,58,214,63,214,68,214,75,212,81,209"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Upper Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Upper Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*<Back Right Upper Leg*/}
                                    <polygon
                                      points="91,206,94,209,97,211,99,212,103,213,108,212,111,214,115,214,117,216,121,220,127,224,126,228,126,232,125,239,123,245,122,251,121,257,120,263,118,269,117,274,116,280,116,286,105,265,92,282,92,273,92,261,93,250,91,246,90,235,90,215"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Upper Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Upper Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Upper Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Left Back Knee */}
                                    <polygon
                                      points="82,290,78,285,77,282,75,277,72,271,69,275,67,279,63,285,62,287,61,286,60,289,60,292,71,302"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Back Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Back Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Back Knee",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Back Knee */}
                                    <polygon
                                      points="117,287,113,284,112,278,109,273,105,267,102,270,100,273,98,277,96,279,92,282,93,288,95,291,105,299,108,293,116,299,115,289"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Back Knee",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Back Knee",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Back Knee",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* <Back Left Lower Leg  */}
                                    <polygon
                                      points="82,293,71,303,60,295,59,297,59,301,57,306,56,311,56,314,56,318,57,321,58,327,59,332,61,337,62,345,64,353,66,359,68,364,68,371,69,376,69,381,82,381,80,376,80,365,80,358,81,348,81,334,83,326,81,317,81,306"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Lower Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Left Lower Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Lower Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Lower Leg  */}
                                    <polygon
                                      points="116,299,108,294,106,300,98,293,95,293,95,297,96,301,96,307,94,313,93,318,93,323,93,330,93,335,95,340,94,348,95,360,96,372,94,379,107,378,107,371,109,360,111,352,113,345,115,337,116,331,118,322,118,312,117,305"
                                      fill={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Lower Leg"),
                                          )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected
                                          ?.split(",")
                                          .map((p) => normalize(p))
                                          .includes(
                                            normalize("Back Right Lower Leg"),
                                          )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Lower Leg",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />

                                    {/* Back Left Ankle Heel */}
                                    <polygon
                                      points="82,382,68,381,68,385,67,387,63,388,59,389,57,392,58,394,62,396,66,396,71,401,76,398,83,399,82,396,82,388"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Ankle Heel",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Ankle Heel",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Ankle Heel",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Ankle Heel */}
                                    <polygon
                                      points="93,380,107,380,107,383,107,386,110,390,115,393,115,396,109,397,103,400,94,402,96,397,93,398"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Ankle Heel",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Ankle Heel",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Ankle Heel",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Upper Hand */}
                                    <polygon
                                      points="40,102,42,98,46,95,50,89,53,85,55,88,56,95,56,101,56,105,55,111,53,118,49,130,43,135,43,122,38,129,35,128,37,116,39,107"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Upper Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Upper Hand */}
                                    <polygon
                                      points="121,86,136,102,136,107,137,109,138,112,139,115,139,117,140,120,140,123,142,131,135,125,134,135,126,130,123,118,120,108,120,100"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Upper Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Upper Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Upper Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Left Elbow */}
                                    <polygon
                                      points="42,125,38,130,36,130,34,128,33,131,34,134,34,141,34,151,41,152,45,147,47,142,50,130,43,136,42,131"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Elbow",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Elbow",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Left Elbow", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/* Back Right Elbow */}
                                    <polygon
                                      points="143,132,136,127,135,136,127,132,129,136,129,140,130,145,138,154,144,153,143,145,148,142,144,135"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Elbow",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Elbow",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Elbow",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Lower Hand */}
                                    <polygon
                                      points="47,143,45,148,43,152,39,152,34,151,33,133,30,137,27,143,25,153,23,161,21,170,20,178,17,187,17,191,27,195,33,179,37,172,40,164,44,155"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Left Lower Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Lower Hand */}
                                    <polygon
                                      points="148,143,144,145,144,148,144,154,141,155,138,154,134,151,130,146,132,154,134,158,136,164,138,168,142,174,145,180,146,185,148,190,151,193,160,191,156,177,153,167,152,158,150,150"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Hand",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Lower Hand",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect(
                                          "Back Right Lower Hand",
                                          "back",
                                        );
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Left Plam */}
                                    <polygon
                                      points="17,191,20,193,26,195,26,199,27,202,26,206,25,211,25,216,23,219,23,222,22,227,18,221,14,233,10,233,10,224,5,231,4,229,8,209,1,215,0,211,3,206,8,199,13,196"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Plam",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Left Plam",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Left Plam", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                    {/*  Back Right Plam */}
                                    <polygon
                                      points="151,194,161,192,164,194,168,197,171,200,176,206,178,210,177,212,170,206,174,229,171,228,168,233,165,233,161,231,159,220,158,230,155,229,154,216,153,205"
                                      fill={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Plam",
                                        )
                                          ? "rgba(255, 0, 0, 0.7)"
                                          : "transparent"
                                      }
                                      stroke={
                                        formData.bodyPartsAffected.includes(
                                          "Back Right Plam",
                                        )
                                          ? "red"
                                          : "black"
                                      }
                                      strokeWidth="1"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        handleSelect("Back Right Plam", "back");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        pointerEvents: "all",
                                      }}
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </>
                        ),
                      },
                    ])}
                  </Col>
                </Row>

                <Snackbar
                  message={snackbarMessage}
                  open={snackbarOpen}
                  onClose={() => setSnackbarOpen(false)}
                  severity={error}
                />
                {/* Buttons */}

                <Row className="mt-3">
                  {selectedRowData && (
                    <Col md={6} className="d-flex justify-content-start mb-2">
                      <Col sm={4} className="d-flex justify-content-start">
                        {selectedRowData ? (
                          <OverlayTrigger
                            show={showTooltip}
                            placement="auto"
                            trigger={["hover", "focus"]} // Important to prevent sticky tooltip
                            delay={{ show: 200, hide: 100 }}
                            overlay={
                              <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                                Logs
                              </Tooltip>
                            }
                          >
                            <button
                              type="button"
                              className="btn btn-primary d-flex align-items-center mx-2"
                              onClick={handlePDFClick}
                              onMouseEnter={() => setShowTooltip(true)}
                              onMouseLeave={() => setShowTooltip(false)}
                            >
                              <span className="material-icons">
                                description
                              </span>
                            </button>
                          </OverlayTrigger>
                        ) : null}

                        <Button
                          variant="outline"
                          className="d-flex align-items-center btn-text-border me-1"
                          onClick={handleBack}
                        >
                          <span className="material-icons mr-2 ">
                            arrow_back
                          </span>
                          Back
                        </Button>

                        <OverlayDrawer
                          title={"Logs"}
                          open={showLogDrawer}
                          onClose={handleCloseLogDrawer}
                          placement="bottom"
                        >
                          <DataTable
                            headers={INJURY_LOG_HEADERS}
                            rows={InjuryLogDetails}
                            isLogTable={true}
                          />
                        </OverlayDrawer>
                      </Col>
                    </Col>
                  )}

                  <Col md={6} className="d-flex justify-content-end mb-2">
                    <Button
                      type="button"
                      variant="outline"
                      className="d-flex align-items-center btn btn-outline-info"
                      onClick={handleCancel} // Apply new cancel logic
                      disabled={view_Case || isStageNonEditable}
                    >
                      <span className="material-icons mr-2">close</span>
                      Cancel
                    </Button>

                    <Button
                      variant="primary"
                      className="btn btn-primary ml-3 d-flex align-items-center"
                      onClick={handleSubmit}
                      disabled={!isChanged || view_Case || isStageNonEditable}
                    >
                      <span className="material-icons me-2">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}
      </div>
    </>
  );
};
export default InjuryForm;
